export class MaintenanceGroup 
{
  GroupId : number;
  Subscriber : string;
  HotelId : number;
  GroupName: string;
  SData: string;
}